import { css as n } from "@microsoft/fast-element";
import { normalize as d } from "../common/normalize.js";
import { display as u, PropertyStyleSheetBehavior as a } from "@matrix42/fast-foundation";
import { slotStyleSheetBehavior as p } from "../common/behaviors/slot-style-sheet-behavior.js";
import { designTokens as o } from "../design-tokens.js";
import { typography as s } from "../styles/typography.js";
import { PropertiesStylesheetBehavior as y } from "../common/behaviors/properties-stylesheet-behavior.js";
function $(r, t) {
  return new a("variant", r, t);
}
function h(r) {
  return r == "primary" ? i : r == "secondary" ? g : r == "outlined" ? b : i;
}
function m() {
  const r = [];
  for (const t of ["primary", "secondary", "outlined"])
    for (const e of ["primary", "secondary", "success", "error"])
      r.push(
        new y(
          ["variant", "color"],
          (l) => l.variant == t && l.color == e,
          h(t)(e)
        )
      );
  return r;
}
function c(r, t) {
  return new a("size", r, t);
}
function i(r) {
  return n`
    .control {
      /* Style */
      background-color: ${o.color[r][100]};
      color: ${o.color.white};
    }

    .control:hover {
      /* Style */
      background-color: ${o.color[r][200]};
    }

    .control:active {
      /* Style */
      outline-color: ${o.color[r][500]};
      background-color: ${o.color[r][400]};
    }
  `;
}
function g(r) {
  return n`
    .control {
      /* Style */
      background-color: ${o.color[r][30]};
      color: ${o.color[r][100]};
    }

    .control:hover {
      /* Style */
      background-color: ${o.color[r][40]};
      color: ${o.color[r][200]};
    }

    .control:active {
      /* Style */
      outline-color: ${o.color[r][500]};
      background-color: ${o.color[r][50]};
      color: ${o.color[r][500]};
    }
  `;
}
function b(r) {
  return n`
    .control {
      /* Style */
      border-color: ${o.color[r][100]};
      background-color: ${o.color.white};
      color: ${o.color[r][100]};
    }

    .control:hover {
      /* Style */
      border-color: ${o.color[r][300]};
      background-color: ${o.color[r][40]};
      color: ${o.color[r][300]};
    }

    .control:active {
      /* Style */
      outline-color: ${o.color[r][500]};
      border-color: transparent;
      background-color: ${o.color[r][50]};
      color: ${o.color[r][500]};
    }

    .control:disabled {
      /* Style */
      border-color: ${o.color.neutral[70]};
      background-color: ${o.color.white} !important;
      color: ${o.color.neutral[70]} !important;
    }
  `;
}
const S = n`
  .control {
    /* Style */
    background-color: transparent;
    color: ${o.color.neutral[100]};
  }

  .control:hover {
    /* Style */
    background-color: ${o.color.neutral[40]};
    color: ${o.color.neutral[100]};
  }

  .control:active {
    /* Style */
    outline-color: ${o.color.neutral[500]};
    background-color: ${o.color.neutral[50]};
    color: ${o.color.neutral[500]};
  }

  .control:disabled {
    /* Style */
    background-color: transparent !important;
    color: ${o.color.neutral[80]} !important;
  }
`, f = n`
  .control {
    /* Layout */
    gap: 0;
  }

  :host([size='sm']) .control {
    /* Layout */
    padding: ${o.spacing[1]};
  }

  :host([size='md']) .control {
    /* Layout */
    padding: ${o.spacing["1.5"]};
  }
`, v = (r) => n`
  .control {
    /* Base */
    min-height: 2em;
    /* Layout */
    /* padding - border (border-box only works with fixed sizes) */
    padding: ${o.spacing[1]} ${o.spacing["1.5"]};
  }

  .content {
    /* Typography */
    ${s("label", "semibold")}
  }

  ::slotted(${r.prefix}-icon) {
    /* Layout */
    width: ${o.iconSize.sm} !important;
    height: ${o.iconSize.sm} !important;
  }
`, k = (r) => n`
  .control {
    /* Base */
    min-height: ${o.spacing[10]};
    /* Layout */
    /* padding - border (border-box only works with fixed sizes) */
    padding: ${o.spacing["1.5"]} ${o.spacing["3.5"]};
  }

  .content {
    /* Typography */
    ${s("p", "semibold")}
  }

  ::slotted(${r.prefix}-icon) {
    /* Layout */
    width: ${o.iconSize.md} !important;
    height: ${o.iconSize.md} !important;
  }
`, W = (r) => n`
    ${d}
    ${u("inline-flex")}
    :host {
      /* Base */
      vertical-align: middle;
    }

    .control {
      /* Base */
      cursor: pointer;
      border: ${o.borderWidth.sm} solid transparent;
      user-select: none;
      width: 100%;
      /* Layout */
      display: inline-flex;
      justify-content: center;
      align-items: center;
      gap: ${o.spacing[2]};
      /* Style */
      border-radius: ${o.borderRadius.sm};
      outline: ${o.borderWidth.sm} solid transparent;
      /* Transition */
      transition: background-color ${o.transition.fast},
        color ${o.transition.fast};
    }

    .control:focus-visible {
      /* Style */
      outline-color: ${o.color.black};
      /* TODO: Use design tokens */
      outline-offset: ${o.borderWidth.sm};
    }

    .control:active {
      /* Style */
      outline-offset: 0;
    }

    .control:disabled {
      /* Base */
      cursor: default;
      /* Style */
      outline: none;
      background-color: ${o.color.neutral[70]} !important;
      color: ${o.color.white} !important;
    }

    .content {
      /* Base */
      vertical-align: middle;
      /* Typography */
      text-transform: uppercase;
    }

    ::slotted(${r.prefix}-icon) {
      /* Style */
      color: inherit;
    }
  `.withBehaviors(
  c("sm", v(r)),
  c("md", k(r)),
  ...m(),
  $("ghost", S),
  p(
    (t) => t.hasContent("start") && !t.hasContent("end") && !t.hasContent("content") || t.hasContent("end") && !t.hasContent("start") && !t.hasContent("content"),
    f
  )
);
export {
  W as buttonStyles
};
